<template>
  <div id="app">
    <LoginPage v-if="$app.islogin === false" @issuccesslogin="$app.islogin = true" />
    <div v-else>
      <AppHeader @logout="logOutApp" />
      <div v-if="$app.userInfo !== null" id="app-content" class="px-0 md:px-[10px] pt-[60px]">
        <router-view></router-view>
      </div>
      <div class="text-center text-gray-300 text-xs">v1:20/11/2025</div>
    </div>
  </div>
</template>

<script>
import AppHeader from './components/layout/AppHeader.vue';
import NavBarItem from './components/component/NavBarItem.vue';
import LoginPage from './components/page/LoginPage.vue';
import { removeFromStorage, getFromStorage } from "@/utils/storage";
const API_URL = process.env.VUE_APP_API_URL
export default {
  name: 'App',
  components: {
    AppHeader,
    NavBarItem,
    LoginPage,
  },
  data() {
    return {
      billTypes: []
    };
  },

  async mounted() {
    const currentPath = window.location.pathname;
    this.$app.islogin = !!localStorage.getItem("uToken")
    if (!currentPath.startsWith('/api') && !currentPath.startsWith('/admin')) {
      await this.checklogin()
      await this.getBillTypes()
      await this.getBillOptions()
    }
    console.log(this.$app.userInfo)
  },

  methods: {
    async checklogin() {
      const token = JSON.parse(getFromStorage("uToken"))
      if (token) {
        await this.$app.getUserByEmail(token).then(res => {
          if(this.$app.userInfo) {
            this.$app.token = token
          }
        })
      }
    },
    checkLoginStatus() {
      this.$app.islogin = !!localStorage.getItem("uToken");

    },
    logOutApp() {
      removeFromStorage("uToken")
      this.$app.islogin = false
    },
    async getBillTypes() {
     await this.$axios.get(`${API_URL}/bill-types`).then(res => {
        if(res.status === 200) {
          this.$app.billTypes = res.data
        }
      }).catch(err => console.log(err))
    },
    async getBillOptions() {
      await this.$axios.get(`${API_URL}/bill-options`).then(res => {
        if (res.status === 200) {
          let list = [];
          if (Array.isArray(res.data)) {
            list = res.data;
          } else if (res.data && Array.isArray(res.data.data)) {
            list = res.data.data.map(item => item.attributes ? { ...item.attributes, id: item.id } : item);
          }
          this.$app.billOptions = list.map(item => ({
            value: Number(item.value),
            text: item.text || item.label
          })).sort((a, b) => a.value - b.value);
        }
      }).catch(err => console.log(err))
    }
  },
  created() {
    window.addEventListener("storage", this.checkLoginStatus); // Lắng nghe thay đổi localStorage
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.checkLoginStatus);
  },
  watch: {
  }
}
</script>
<style scoped>
</style>
